export default __webpack_public_path__ + "static/media/fifth-peculiarity-bg.f6ff677d.svg";